import React from 'react'
import { Controller } from 'react-hook-form'
import Select from 'react-select'

const MultiSelect = ({name, label, options, control}) => {
  return <div className='row'>
    <label className='reconcile-label col-lg-4'>{label}</label>
    <div className='col-lg-7'>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Select
            multi
            value={field.value}
            options={options}
            onChange={values => field.onChange(values)}
          />
        )}
      />
    </div>
  </div>
}

export default MultiSelect
